// extracted by mini-css-extract-plugin
export default {"warning":"ChangeCoverageWarning_warning__HiB11"};